import React from "react";
import "./NMahakam.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Modern6images from "../../Media/Residential/Modern Mansion/Modern6";
import Modern7images from "../../Media/Residential/Modern Mansion/Modern7";

const imageMap = {
  Modern6images,
  Modern7images,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="promonewlaunching" className="modernmansion">
      <h1>New Launching</h1>
      <h2>Modern Mansion</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
